import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=1f4e424b&scoped=true&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=1f4e424b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e424b",
  null
  
)

export default component.exports